import { render, staticRenderFns } from "./ReviewDocumentsModal.vue?vue&type=template&id=55262846&scoped=true"
import script from "./ReviewDocumentsModal.vue?vue&type=script&lang=js"
export * from "./ReviewDocumentsModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewDocumentsModal.vue?vue&type=style&index=0&id=55262846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55262846",
  null
  
)

export default component.exports